import { beam } from '@styles/colors/themes';

interface IWarrantyStatus {
  label: string;
  daysYears: string;
  color: string;
  daysNumber?: number;
}
const DAY_TIME = 1000 * 60 * 60 * 24;
export const getWarrantyStatus = (
  purchasedDate?: Date | null,
  productWarrantyLength?: number | null,
): IWarrantyStatus => {
  if (!purchasedDate) {
    return {
      label: 'No Purchased Date',
      daysYears: '',
      color: beam.font.missing,
    };
  }
  const todayDate = new Date();
  const oldProduct = Math.floor(
    (purchasedDate.getTime() - todayDate.getTime()) / (DAY_TIME * 365),
  );
  if (oldProduct < -15) {
    return {
      label: 'Expired',
      daysYears: `${Math.abs(oldProduct) - 1}y`,
      color: '#ff0000',
      daysNumber: oldProduct,
    };
  }
  if (!productWarrantyLength) {
    return {
      label: 'No Warranty Info',
      daysYears: '',
      color: beam.font.missing,
    };
  }
  const timeWithWarranty =
    purchasedDate.getTime() + productWarrantyLength * DAY_TIME;
  const remainWarrantyDays = Math.floor(
    (timeWithWarranty - todayDate.getTime()) / DAY_TIME,
  );
  if (remainWarrantyDays < 0 && remainWarrantyDays < -365) {
    return {
      label: 'Expired',
      daysYears: `${Math.abs(Math.floor(remainWarrantyDays / 365)) - 1}y`,
      color: '#ff0000',
      daysNumber: remainWarrantyDays - 1,
    };
  }
  if (remainWarrantyDays < 0) {
    return {
      label: 'Expired',
      daysYears: `${Math.abs(remainWarrantyDays) - 1}d`,
      color: '#ff0000',
      daysNumber: remainWarrantyDays - 1,
    };
  }
  if (remainWarrantyDays >= 0 && remainWarrantyDays > 365) {
    return {
      label: 'Active',
      daysYears: `${Math.floor(remainWarrantyDays / 365) + 1}y`,
      color: '#06dc00',
      daysNumber: remainWarrantyDays - 1,
    };
  }
  if (remainWarrantyDays >= 0 && remainWarrantyDays < 30) {
    return {
      label: 'Expiring Soon',
      daysYears: `${remainWarrantyDays + 1}d`,
      color: '#df6f00',
      daysNumber: remainWarrantyDays - 1,
    };
  }
  return {
    label: 'Active',
    daysYears: `${remainWarrantyDays + 1}d`,
    color: '#06dc00',
    daysNumber: remainWarrantyDays - 1,
  };
};
